import { createSlice } from "@reduxjs/toolkit";

export const productsSlice =  createSlice({
    name: 'products',
    initialState: {
        productsLoading: 'idle',
        products: [],
        familyVersions: []
    },
    reducers: {
        productsLoading(state ,action){
            if(state.productsLoading == 'idle'){
                state.productsLoading = 'pending'
            }
        },
        productsSet(state, action) {
            if(state.productsLoading == 'pending'){
                state.productsLoading = 'idle';
                state.products = action.payload
            }
        },
        familyVersionsSet(state, action) {
            state.familyVersions = action.payload;
        }


    }
});
export const { productsLoading, productsSet, familyVersionsSet } = productsSlice.actions;

export const loadProducts = (products) => dispatch => {
    dispatch(productsLoading());
    dispatch(productsSet(products));
}

const reducer = productsSlice.reducer;
export default reducer
